import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { getDirectoryMain } from 'src/app/api/repositorio';
import FusePageSimple from '../../../@fuse/core/FusePageSimple';
import { getRoles } from '../../store/fuse/roles';
import { getNotifications } from '../../theme-layouts/shared-components/notificationPanel/store/dataSlice';
import { addDocument, addFolder } from '../../store/fuse/repository';
import StructureRepositorio from './structure_repositorio';
import { StyleModal } from '../modal/styles';
import { REPOSITORY } from '../../constants/repository';
import AddFolder from './forms/AddFolder';
import AddDocument from './forms/AddDocument';
import Error404Page from "../404/Error404Page";

const Root = styled(FusePageSimple)(({ theme }) => ({
  '& .FusePageSimple-header': {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider,
  },
  '& .FusePageSimple-toolbar': {},
  '& .FusePageSimple-content': {},
  '& .FusePageSimple-sidebarHeader': {},
  '& .FusePageSimple-sidebarContent': {},
}));

function Repositorio() {
  const { keycloak } = useKeycloak();
  const roleKeycloak = keycloak?.realmAccess?.roles[0];

  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];

  const { roles } = useSelector((state) => state.fuse.roles);
  const userRole = keycloak.resourceAccess?.puv?.roles[0];
  const [textModal, setTextModal] = useState();

  const dispatch = useDispatch();
  const initRoles = () => dispatch(getRoles());
  const addCreateDocument = (document) => dispatch(addDocument(document));
  const addCreateFolder = (folder) => dispatch(addFolder(folder));

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const navigate = useNavigate();

  const [folder, setFolder] = useState();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    fetchData();
  };

  const [mainDirectory, setMainDirectory] = useState([]);
  const [refreshMainDirectory, setRefreshMainDirectory] = useState(false);

  const [form, setForm] = useState({
    name: '',
    status: '',
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleFolder = (event) => {
    setFolder(event.target.value);
  };

  useEffect(() => {
    initRoles();
    if (keycloak?.tokenParsed?.sub) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak?.tokenParsed]);

  useEffect(() => {
    if (refreshMainDirectory) {
      fetchData();
      setRefreshMainDirectory(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshMainDirectory]);

  const fetchData = async () => {
    try {
      dispatch(getNotifications({ idUser: id, roleId }));
      const data = await getDirectoryMain(keycloak?.tokenParsed?.sub, userRole);
      setMainDirectory(data);
    } catch (error) {
      console.log('error get directory', error);
    }
  };

  const { name, status } = form;

  const onChangeInput = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const create = (text) => {
    // if (text === "Crear Documento") addCreateDocument(document);
    // if (text === "Crear Carpeta") addCreateFolder(document);

    // Clean Form and Modal
    setOpen(false);
    setForm({
      name: '',
      status: '',
    });
  };

  const [searchValue, setSearchValue] = useState(null);
  const [contentModal, setContentModal] = useState('');

  return (
    <>
      {['NOC', 'Administrador'].includes(roleKeycloak) ? (
        <Root
          content={
            <div className="w-full p-24">
              <div className="flex mb-4">
                <div
                  className=" w-full flex-col m-10 rounded-lg mt-0 p-10"
                  style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
                >
                  <div>
                    {/* Content */}
                    <div className="flex mb-4">
                      <StructureRepositorio mainDirectory={mainDirectory} setRefreshMainDirectory={setRefreshMainDirectory} />
                    </div>
                    {/* Footer Actions */}
                    {userRole === 'Autor' && (
                      <div className="button-document">
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ margin: '10px' }}
                          onClick={() => {
                            setContentModal(REPOSITORY.FOLDER);
                            setOpen(true);
                          }}
                        >
                          Crear Carpeta
                        </Button>
                        {/* <Button
                          variant="contained"
                          color="success"
                          style={{ margin: "10px" }}
                          onClick={() => {
                            setContentModal(REPOSITORY.DOCUMENT);
                            setOpen(true);
                          }}
                        >
                          Subir Documento
                        </Button> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          }
          scroll="content"
        />
      ): (
        <Error404Page />
      )}
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={StyleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {contentModal === REPOSITORY.FOLDER ? 'Crear Carpeta' : 'Subir Documento'}
          </Typography>
          {contentModal === REPOSITORY.FOLDER ? (
            <AddFolder handleClose={handleClose} folderId={0} fromDirectory tabSelectedHandle={() => {}} />
          ) : (
            <AddDocument handleClose={handleClose} />
          )}
        </Box>
      </Modal>
    </>
  );
}

export default Repositorio;
